import { DateTime } from "luxon";
import {
  SELECTED_TRANSFER_CHANGE,
  SELECTED_TRANSFER_IDLE,
  SELECTED_TRANSFER_LOADING,
  SELECTED_TRANSFER_RESET,
  SELECTED_TRANSFER_UPDATE,
  TRANSFER_FILTERS_CHANGE,
  TRANSFER_FILTERS_INIT,
  TRANSFER_FILTERS_UPDATE,
  TRANSFER_SEARCH_FORM_CHANGE,
  TRANSFER_SEARCH_FORM_RESET,
  TRANSFER_SEARCH_FORM_UPDATE,
  TRANSFER_SEARCH_RESULTS_CHANGE,
  TRANSFER_SEARCH_RESULTS_IDLE,
  TRANSFER_SEARCH_RESULTS_LOADING,
  TRANSFER_SEARCH_RESULTS_RESET,
  TRANSFER_SEARCH_RESULTS_UPDATE,
  TRANSFER_SINGLE_FILTER_INIT,
} from "../actions/search/types";

const TransfersSearchFormInitial = {
  adults: 2,
  children: 0,
  children_ages: [],
  inboundPickupDate: DateTime.now().plus({ days: 1 }).toISO(),
  origin: {},
  destination: {},
  search_session_id: null,
  tripMode: "air_to_poi",
  searchPayload: {},
};
export const TransfersSearchForm = (
  state = TransfersSearchFormInitial,
  action
) => {
  switch (action.type) {
    case TRANSFER_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case TRANSFER_SEARCH_FORM_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TRANSFER_SEARCH_FORM_RESET: {
      return TransfersSearchFormInitial;
    }
    default:
      return state;
  }
};

const TransfersSearchResultsInitial = {
  transfers: [],
  loading: false,
  failed: false,
  page_session_id: null,
  search_session_id: null,
  api_uid: null,
};
export const TransfersSearchResults = (
  state = TransfersSearchResultsInitial,
  action
) => {
  switch (action.type) {
    case TRANSFER_SEARCH_RESULTS_LOADING: {
      return { ...state, loading: true };
    }
    case TRANSFER_SEARCH_RESULTS_IDLE: {
      return { ...state, loading: false };
    }
    case TRANSFER_SEARCH_RESULTS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TRANSFER_SEARCH_RESULTS_UPDATE: {
      const { results } = action;
      return { ...state, ...results };
    }
    case TRANSFER_SEARCH_RESULTS_RESET: {
      return TransfersSearchResultsInitial;
    }
    default:
      return state;
  }
};

const TransfersFiltersInitial = {
  budget: [0, 1],
  vehicle: [],
  provider: [],
  order_by: "PRD",
};
export const TransfersFilters = (state = TransfersFiltersInitial, action) => {
  switch (action.type) {
    case TRANSFER_FILTERS_INIT: {
      return TransfersFiltersInitial;
    }
    case TRANSFER_SINGLE_FILTER_INIT: {
      const { key } = action;
      return { ...state, [key]: TransfersFiltersInitial[key] };
    }
    case TRANSFER_FILTERS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TRANSFER_FILTERS_UPDATE: {
      const { filters } = action;
      return { ...state, ...filters };
    }
    default:
      return state;
  }
};

const TransferSelectedInitial = {
  transfer: {},
  session_id: "",
  loading: false,
  failed: false,
};
export const TransferSelected = (state = TransferSelectedInitial, action) => {
  switch (action.type) {
    case SELECTED_TRANSFER_LOADING: {
      return { ...state, loading: true };
    }
    case SELECTED_TRANSFER_IDLE: {
      return { ...state, loading: false };
    }
    case SELECTED_TRANSFER_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SELECTED_TRANSFER_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case SELECTED_TRANSFER_RESET: {
      return TransferSelectedInitial;
    }
    default:
      return state;
  }
};
